<template>
    <div class="axethrow">
      {{ thrw.basicScore }}
    </div>
</template>

<style scoped>
  .axethrow {
    font-family: '28 Days Later';
    color: rgb(240, 253, 56);
    font-size: 2em;
    position: relative;
    left: -5px;
    width: 30px;
    height: 50px;
  }
</style>

<script>
export default {
  props: [
    'thrw'
  ]
}
</script>
